// T1 · Loupe — plein écran très grands caractères pour une commande (client,
// heure, pizzas + modifs parsées D6). Bandeau « mode écriture manuelle ».
// Lecture seule. Le nom de pizza est résolu via le catalogue (hook/wrapper).
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useCatalogue } from '@/hooks/useCatalogue';
import { useNumerosService } from '@/hooks/useNumerosService';
import { nomAffichage } from '@/lib/affichage-commande';
import { parseNotes } from '@/lib/notes-convention';
import { formatHeure } from '@/lib/format';
import type { Commande, CommandePizza } from '@/db/schema';

interface Props {
  commande: Commande;
  lignes: CommandePizza[];
  onClose: () => void;
}

export function Loupe({ commande, lignes, onClose }: Props) {
  const catalogue = useCatalogue();
  const numeros = useNumerosService();
  const nomParId = new Map(catalogue.map((p) => [p.id as number, p.nom]));

  return (
    <div className="fixed inset-0 z-50 flex flex-col gap-6 overflow-auto bg-background p-8">
      <div className="flex items-center justify-between">
        <span className="font-cormorant text-2xl italic text-muted-foreground">
          Mode écriture manuelle
        </span>
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          className="min-h-[80px] min-w-[80px] text-xl"
        >
          Fermer
        </Button>
      </div>

      <div className="flex items-baseline justify-between">
        <span className="font-cormorant text-5xl italic">
          {nomAffichage(commande, numeros)}
        </span>
        <span className="font-mono text-5xl">
          {formatHeure(commande.heure_retrait_proposee)}
        </span>
      </div>

      <ul className="flex flex-col gap-5">
        {lignes.map((l) => {
          const parsed = parseNotes(l.notes_libres ?? '');
          return (
            <li key={l.id} className="flex flex-col gap-2">
              <span className="font-jost text-4xl font-bold">
                {l.qty}× {nomParId.get(l.pizzaId) ?? `Pizza #${l.pizzaId}`}
              </span>
              {parsed.mod.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {parsed.mod.map((m, i) => (
                    <Badge
                      key={`${m}-${i}`}
                      variant="secondary"
                      className="text-2xl"
                    >
                      {m}
                    </Badge>
                  ))}
                </div>
              )}
              {parsed.texte && (
                <span className="font-cormorant text-3xl italic">
                  {parsed.texte}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
